// extracted by mini-css-extract-plugin
export default {"element":"LargeNumbers-module--element--f57f2","link":"LargeNumbers-module--link--ca5d0"};